'use strict'

import Vue from 'vue'

import SettingsGeneralTab from './SettingsGeneralTab.vue'
import SettingsGeneralPluginsTab from './SettingsGeneralPluginsTab.vue'
import SettingsMachineTab from './SettingsMachineTab.vue'
import SettingsMachinePluginsTab from './SettingsMachinePluginsTab.vue'

Vue.use(SettingsGeneralTab)
Vue.use(SettingsGeneralPluginsTab)
Vue.use(SettingsMachineTab)
Vue.use(SettingsMachinePluginsTab)

